import { isBaby } from './baby';

export const getItemOrigin = () => (isBaby() ? 'BABY_REGISTRY' : 'WEDDINGS');
